import { useState } from 'react';
import PropTypes from 'prop-types';
import { Tab } from '@headlessui/react';
import LargeModal from '../../components/Modal/LargeModal';
import ShipmentDetailForm from '../SampleReport/ShipmentDetailForm';
import IconLink from '../../components/Icon/IconLink';

const GeneralDetailModal = ({
  open, onClose, data, isMetric, sampleData, updateFunction, orderId, trackingNumbers, trackingUrl, labelUrl
}) => {
    const [orderDetailData, setOrderDetailData] = useState(sampleData);

    const onCloseButtonClickHandler = () => {
        onClose();
    };

    const onSubmitHandler = async (formData) => {
        updateFunction(formData, orderId);
        onCloseButtonClickHandler();
    };

    return (
        <LargeModal open={open} setOpen={onCloseButtonClickHandler}>
            <div>
                <Tab.Group>
                    <Tab.Panels>
                        <h2 className="font-bold pb-4">Order Details</h2>

                        <div className="flex flex-row w-full text-white text-sm pt-4 h-16">
                            <div className="w-[10%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Glass Type</h2>
                            </div>
                            <div className="w-[10%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Performance</h2>
                            </div>
                            <div className="w-[10%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Drawing</h2>
                            </div>
                            <div className="w-[45%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Product</h2>
                            </div>
                            <div className="w-[10%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Note</h2>
                            </div>
                            <div className="w-[15%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                <h2 className="text-center">Quantity & Sample Size</h2>
                            </div>
                        </div>

                        {orderDetailData.map((item) => (
                            <div className="flex flex-row w-full h-auto text-xs">
                                <div className="w-[10%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <h2 className="text-center">{item.family}</h2>
                                </div>
                                <div className="w-[10%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <div className="flex flex-col">
                                        <h2>VLT: {item.description_visible}</h2>
                                        <h2>LSG: {item.light_solar_gain_ration}</h2>
                                        <h2>SC: {item.shading_coefficient}</h2>
                                        <h2>SHGC: {item.solar_heat_gain_coefficient}</h2>
                                        <h2>Summer U: {isMetric ? item.u_value_summer_metric : item.u_value_summer}</h2>
                                        <h2>Winter U: {isMetric ? item.u_value_solar_metric : item.u_value_solar}</h2>
                                        <h2>R Out: {item.reflectance_out}</h2>
                                    </div>
                                </div>
                                <div className="w-[10%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <h2 className="text-center">{item.drawing}</h2>
                                </div>
                                <div className="w-[45%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white whitespace-pre-line p-2">
                                    <h2 className="text-center">
                                        {isMetric && (
                                            <>
                                                <div>{item.top_line_metric}</div>
                                                {item.spec_metric.map((line, index) => (
                                                    <div>{line}</div>
                                                ))}
                                            </>
                                        )}
                                        {!isMetric && (
                                            <>
                                                <div>{item.top_line_imp}</div>
                                                {item.spec_imp.map((line, index) => (
                                                    <div>{line}</div>
                                                ))}
                                            </>
                                        )}
                                    </h2>
                                </div>
                                <div className="w-[10%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <h2 className="text-center">{item.note}</h2>
                                </div>
                                <div className="w-[15%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                    <h2 className="text-center">{item.quantity}x</h2>
                                    <h2 className="text-center pl-2">{item.sampleSize}</h2>
                                </div>
                            </div>
                        ))}
                    </Tab.Panels>
                </Tab.Group>
            </div>
            <div>
                <Tab.Group>
                    <Tab.Panels>
                        <ShipmentDetailForm data={[]}  prevFormData={data} submitFunction={onSubmitHandler} buttonLabel="Update Order" isEditable="false" />
                    </Tab.Panels>
                </Tab.Group>
            </div>
            {trackingNumbers.length > 0 &&
                <div>
                    <Tab.Group>
                        <Tab.Panels>
                            <div className="flex flex-row w-full text-white text-sm pt-4 h-16">
                                <div className="w-[33%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                    <h2 className="text-center">Tracking Number</h2>
                                </div>
                                <div className="w-[33%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                    <h2 className="text-center">Tracking URL</h2>
                                </div>
                                <div className="w-[34%] flex justify-center items-center bg-[#0d3857] border-solid border-r-2 border-white group relative cursor-pointer">
                                    <h2 className="text-center">UPS Label URL</h2>
                                </div>
                            </div>

                            {trackingNumbers.map((item, index) => (
                                <div className="flex flex-row w-full h-auto text-xs">
                                    <div className="w-[33%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                        <h2 className="text-center">{item}</h2>
                                    </div>
                                    <div className="w-[33%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                        <button
                                            type="submit"
                                            onClick={() => window.open(trackingUrl[index], "_blank", "noopener,noreferrer")}
                                            className="p-2 group relative cursor-pointer"
                                            aria-label="Open Tracking URL"
                                        >
                                            <IconLink />
                                        </button>
                                    </div>
                                    <div className="w-[34%] flex justify-center items-center bg-[#f3f6f7] border-solid border-r-2 border-b-2 border-white p-2">
                                        {labelUrl[index] !== '' &&
                                            <button
                                                type="submit"
                                                onClick={() => window.open(labelUrl[index], "_blank", "noopener,noreferrer")}
                                                className="p-2 group relative cursor-pointer"
                                                aria-label="Open UPS Label URL"
                                            >
                                                <IconLink />
                                            </button>
                                        }
                                        {labelUrl[index] === '' &&
                                            <h2>Manuel Entry</h2>
                                        }
                                    </div>
                                </div>
                            ))}

                        </Tab.Panels>
                    </Tab.Group>
                </div>
            }
        </LargeModal>
    );
};

GeneralDetailModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    isMetric: PropTypes.bool.isRequired,
    sampleData: PropTypes.object.isRequired,
    updateFunction: PropTypes.func,
    orderId: PropTypes.string.isRequired,
    trackingNumbers: PropTypes.array.isRequired,
    trackingUrl: PropTypes.array.isRequired,
    labelUrl: PropTypes.array.isRequired,
};

GeneralDetailModal.defaultProps = {
    updateFunction: () => console.log('Update Function Handle'),
};

export default GeneralDetailModal;
